import { GlobalHeader } from '@design-system/global-header';
import React from 'react';

import { useAutocomplete } from '~/hooks/useAutocomplete';
import { headerMapper } from '~/mappers/header';
import { Header } from '~/mappers/header/models';
import { gtmService } from '~/services/gtm';

const HeaderWrap = (header: Header) => {
  const { autocompleteState, getInputProps } = useAutocomplete();

  const mapped = headerMapper(header);

  return (
    <GlobalHeader
      {...{
        ...mapped,
        search: mapped.search
          ? {
              ...mapped.search,
              autocomplete: { autocompleteState, getInputProps },
            }
          : undefined,
        onClickNavItem: (value) => gtmService.emitHeaderMenuClick(value),
      }}
    />
  );
};

export default HeaderWrap;
